import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { useGetDropDownFlagList } from 'features/assigned-clients/use-cases/drop-down-flag';
// import { useUploadImage } from 'features/assigned-clients/use-cases/upload-image';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { validateFileBeforeUpload } from 'routes/utils';
export const DocumentsInfoFormItems = ({
  data,
  // isFetching,
  fileList,
  previewImage,
  previewOpen,
  setFileList,
  setPreviewOpen,
  setIsImageUploading,
  setPreviewImage,
  setFileNames,
  isImageUploading,
}: any) => {
  const [subCategoryValue, setSubCategoryValue] = useState('');
  const [subClassValue, setSubClassValue] = useState<any>('');
  const { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [blobUrls, setBlobUrls] = useState<string[]>([]);
  const ids = searchParams.get('clsid');
  // const { mutate: uploadImage } = useUploadImage();
  const { data: subCategory } = useGetDropDownFlagList({
    Flag: 'SubCategory',
    ParentId: subCategoryValue,
    ClientId: ids,
    CompanyId: id,
  });
  const initialValues = async () => {
    try {
      const apires: any = await AssignedClientsApiService().dropDownByClassFlag(
        {
          Flag: 'Class',
          ParentId: subClassValue,
          ClientId: ids,
          CompanyId: id,
        },
      );
      setSubClassValue(apires);
    } catch (error: any) {
      message.error(error);
    }
  };
  // const handleImageUpload = (file: UploadFile) => {
  //   const formData = new FormData();
  //   formData.append('file', file as any);

  //   setIsImageUploading(true); // Set uploading state to true

  //   uploadImage(
  //     { id: id as string, formData }, // Pass id and file as payload
  //     {
  //       onSuccess: (response: any) => {
  //         // setBlobUrl(response?.blobUrl); // Save blob URL
  //         setFileNames((prev: any) => [...prev, response.fileName]);
  //         message.success('File uploaded successfully');
  //         setIsImageUploading(false); // Reset uploading state
  //       },
  //       onError: (error) => {
  //         message.error('File upload failed');
  //         console.error('File upload failed, error:', error); // Log error for debugging
  //         setIsImageUploading(false); // Reset uploading state
  //       },
  //     },
  //   );
  // };
  const handleImageUpload = async (file: UploadFile) => {
    const formData = new FormData();
    formData.append('file', file as any);
    setIsImageUploading(true);
    try {
      // API call to upload the image with separate arguments
      const response = await AssignedClientsApiService().uploadImageDocument(
        id as string, // Pass the id as the first argument
        formData, // Pass the formData as the second argument
      );
      // Assuming the response contains a fileName
      setFileNames((prev: any) => [...prev, response.fileName]);
      setBlobUrls((prev) => [...prev, response.blobUrl]); // Store the blob URL for each file
      message.success('File uploaded successfully');
    } catch (error) {
      message.error('Image upload failed');
    } finally {
      setIsImageUploading(false);
    }
  };
  const beforeUpload = (file: any) => {
    // Validate file before upload
    const isValid = validateFileBeforeUpload(file);

    if (isValid) {
      handleImageUpload(file); // Call handleImageUpload only if valid
    }

    return isValid; // If false, upload will be prevented
  };
  const handlePreview = async (file: UploadFile, index: number) => {
    // Use the blob URL for previewing the specific file
    setPreviewImage(blobUrls[index] || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type='button'>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  useEffect(() => {
    if (subClassValue) {
      initialValues();
    }
  }, [subClassValue]);

  return (
    <Fragment>
      <Form.Item
        name={'DocumentName'}
        label={'Document Name'}
        rules={[
          {
            required: true,
            whitespace: false,
          },
        ]}
      >
        <Input placeholder={'Enter Documents Name'} />
      </Form.Item>
      <Form.Item
        label='Category'
        name={'category'}
        rules={[
          {
            required: true,
            message: 'Category is required',
          },
        ]}
      >
        <Select
          options={data?.data?.rc?.map((item: any) => ({
            label: item.text,
            value: item.value,
          }))}
          onChange={(value) => setSubCategoryValue(value)}
          placeholder='Please Select'
        />
      </Form.Item>
      {subCategoryValue && (
        <Form.Item name={'SubCategory'} label={'Sub Category'}>
          <Select
            options={subCategory?.data.rc?.map((item: any) => ({
              label: item.text,
              value: item.value,
            }))}
            onChange={(value) => setSubClassValue(value)}
            placeholder='Please Select'
          />
        </Form.Item>
      )}
      {subClassValue?.data?.rc.length > 0 && (
        <Form.Item name={'class'} label={'Class'}>
          <Select
            options={subClassValue?.data?.rc.map((item: any) => ({
              label: item.text,
              value: item.value,
            }))}
            placeholder='Please Select'
          />
        </Form.Item>
      )}
      <Form.Item label={'Upload Documents'} name={'file'}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Upload
            action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
            listType='picture-card'
            fileList={fileList}
            onPreview={(file) => handlePreview(file, fileList.indexOf(file))}
            onChange={handleChange}
            multiple={true}
            maxCount={5}
            style={{ width: '100%' }}
            accept='.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.pdf'
            className='upld_docs'
            beforeUpload={beforeUpload}
          >
            {fileList?.length >= 50 ? null : (
              <div style={{ width: '100%' }}>{uploadButton}</div>
            )}
          </Upload>

          {/* Button for each uploaded file */}
          {fileList.length > 0 && (
            <div style={{ width: '100%', marginTop: '10px' }}>
              {fileList.map((file: UploadFile, index: any) => (
                <Row
                  key={file.uid}
                  align='middle'
                  justify='space-between'
                  style={{
                    marginBottom: '10px',
                    padding: '8px',
                    background: '#f5f5f5',
                    borderRadius: '8px',
                  }}
                >
                  <Col span={16}>
                    <div>{file.name}</div>
                  </Col>
                  <Col span={8} style={{ textAlign: 'right' }}>
                    <Button
                      type='primary'
                      onClick={() => handlePreview(file, index)}
                      style={{
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        marginLeft: '8px',
                        borderRadius: '8px',
                      }}
                    >
                      Preview
                    </Button>
                  </Col>
                </Row>
              ))}
            </div>
          )}

          {/* Display loading spinner when image is uploading */}
          {isImageUploading && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1,
              }}
            >
              <Spin size='large' />
            </div>
          )}

          {/* Modal for image preview */}
          <Modal
            open={previewOpen}
            onCancel={() => setPreviewOpen(false)}
            footer={null}
            centered
            width={800}
          >
            {previewImage?.endsWith('.jpg') ||
            previewImage?.endsWith('.jpeg') ||
            previewImage?.endsWith('.png') ||
            previewImage?.endsWith('.webp') ? (
              <img src={previewImage} alt='Preview' />
            ) : (
              <iframe
                src={`https://docs.google.com/gview?url=${previewImage}&embedded=true`}
                style={{ width: '100%', height: '600px', border: 'none' }}
                title='Document Preview'
              />
            )}
          </Modal>
        </div>
      </Form.Item>
    </Fragment>
  );
};
